<agpr-take-over-panel
    [id]="id"
    class="agpr-clickOutsideExcluded"
    [header]="mode === savedFilterSetupMode.create ? 'Create Saved Filter' : 'Edit Saved Filter'"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [width]="80"
>
    <div class="agpr-savedFilterSetup-container">
        <div class="agpr-savedFilterSetup-lhp">
            <agpr-text-input
                class="agpr-savedFilterSetup-newNameInput"
                label="Common.filter.savedFilters.nameInput"
                [(ngModel)]="filterName"
                (ngModelChange)="clearErrors()"
                [placeholder]="'Common.filter.savedFilters.newSavedFilter.name.placeholder'"
                maxlength="64"
                [bottomMargin]="false"
            ></agpr-text-input>
            <div
                class="agpr-savedFilterSetup-error"
                *ngIf="showErrors"
            >
                <agpr-form-message
                    *ngIf="errors.duplicate"
                    [marginBottom]="0"
                >
                    {{  'Common.filter.savedFilters.newSavedFilter.name.duplicateError' | localize }}
                </agpr-form-message>
                <agpr-form-message
                    *ngIf="errors.empty"
                    [marginBottom]="0"
                >
                    {{ 'RSSFeeds.name.errors.empty' | localize }}
                </agpr-form-message>
                <agpr-form-message
                    *ngIf="errors.invalidLength"
                    [marginBottom]="0"
                >
                    {{ 'Common.filter.savedFilters.newSavedFilter.name.invalidLength' | localize }}
                </agpr-form-message>
            </div>
            <agpr-scroll-panel class="agpr-savedFilterSetup-lhp-scrollPanel">

                <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                <ul
                    [id]="id + '_filterTypes'"
                    class="agpr-savedFilterSetup-lhpList"
                    agprListKeyboardNavigation
                >
                    <ng-container *ngFor="let section of filterSections; index as secIndex">
                        <li
                            class="filterType filterTypeGroup agpr-unfocusableListItem"
                        >
                            <h3> {{ "Social.filter.section." + section | localize }} </h3>
                        </li>
                        <li
                            *ngFor="let filter of filters[section]; index as i"
                            class="filterType"
                            [ngClass]="{
                                'filterType--selected': filter === activeFilter
                            }"
                            [id]="id + '_' + secIndex + '_filterType_' + i"
                            (keydown)="selectFilterType(filter, $event)"
                            (click)="selectFilterType(filter)"
                        >
                            {{ filter?.label | localize }}
                        </li>
                    </ng-container>
                    <li
                        *ngFor="let filter of filtersWithoutSection; index as i"
                        class="filterType"
                        [ngClass]="{
                            'filterType--selected': filter === activeFilter
                        }"
                        [id]="id + '.filterType_' + i"
                        (keydown)="selectFilterType(filter, $event)"
                        (click)="selectFilterType(filter)"
                    >
                        {{ filter?.label | localize }}
                    </li>
                </ul>
                <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
            </agpr-scroll-panel>
        </div>
        <div
            class="agpr-savedFilterSetup-filterContent"
            [agprLoading]="activeFilter?.loading"
        >
            <agpr-filter-wrapper
                [filter]="activeFilter"
                [style]="style"
                [id]="id"
            ></agpr-filter-wrapper>
        </div>
        <div class="agpr-savedFilterSetup-chipContainer">
            <agpr-scroll-panel>
                <div class="activeFilter-container">
                    <ng-container *ngFor="let filter of flatFilters">
                        <ng-container
                            *ngIf="
                                filter.currentChips &&
                                filter.currentChips.length > 0
                            "
                        >
                            <div class="activeFilter-label">
                                {{ filter.label | localize }}
                            </div>
                            <label
                                *ngIf="filter.currentIncludeExclude && filter.showIncludeExclude"
                                class="activeFilter-subLabel"
                            >
                                {{ (filter.currentIncludeExclude === includeExclude.include ?
                                    'Common.filter.included' :
                                    'Common.filter.excluded') | localize }}
                            </label>
                            <ul
                                [id]="id + '_activeFilters'"
                                class="activeFilter-contents"
                                agprListKeyboardNavigation
                                listOrientation="horizontal"
                                [focusOnChild]="true"
                                [list]="filter.currentChips"
                                role="group"
                                [attr.aria-label]="filter.label | localize"
                            >
                                <ng-container *ngFor="let chip of filter.currentChips; let i = index">
                                    <div
                                        *ngIf="chip.labelArgs?.['firstInGroup'] && !chip.labelArgs?.['firstInFilter']"
                                        class="activeFilter-groupLabel"
                                    >
                                        {{ 'and' | localize }}
                                    </div>
                                    <li
                                        class="agpr-chip"
                                        [id]="id + '.chip_' + i"
                                    >
                                        <span
                                            class="agpr-chip-label"
                                            [pTooltip]="chip.tooltip ? (chip.tooltip | localize) : (chip.label | localize: chip.labelArgs)"
                                            tooltipPosition="top"
                                        >
                                            {{
                                                (chip.label | localize: chip.labelArgs) + (chip.suffix | localize)
                                            }}
                                        </span>
                                        <agpr-button
                                            [id]="id + '.chip_' + i + '.delete'"
                                            class="agpr-chip-button"
                                            [style]="buttonTypes.icon"
                                            icon="agpr-i-close"
                                            tooltip="Common.forms.chips.delete"
                                            tooltipPosition="top"
                                            [ariaLabel]="(chip.label | localize: chip.labelArgs) + ' ' + ('Common.forms.chips.delete' | localize)"
                                            (click)="removeChip(filter, chip)"
                                        ></agpr-button>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>
                    </ng-container>
                </div>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #takeOverFooterLeft class="agpr-savedFilterSetup-footer">
        <agpr-button
            [id]="id + '.cancelButton'"
            label="Core.button.cancel"
            (click)="cancel()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
        <agpr-button
            [id]="id + '.clearButton'"
            label="Core.button.clear"
            (click)="clear()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '.applyButton'"
            [label]="mode === savedFilterSetupMode.create ? 'create' : 'save'"
            (click)="apply()"
            [style]="buttonTypes.primary"
            [disabled]="isSavedFilterClean"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
